import { Controller } from "@hotwired/stimulus"
import Tribute from "tributejs"

// Controller for template variable autocomplete
// Triggers autocomplete when user types "{{" in content fields
export default class extends Controller {
  static targets = ["content"]
  static values = {
    variables: Array  // Liste des variables disponibles depuis le backend
  }

  connect() {
    this.initializeTribute()
  }

  disconnect() {
    if (this.tribute) {
      this.contentTargets.forEach(target => {
        this.tribute.detach(target)
      })
    }
  }

  initializeTribute() {
    // Configuration Tribute.js
    this.tribute = new Tribute({
      // Déclencher sur "{{"
      trigger: "{{",

      // Ne pas ajouter d'espace après insertion
      spaceSelectsMatch: false,

      // Recherche permissive
      searchOpts: {
        pre: "",
        post: "",
        skip: false
      },

      // Liste des variables
      values: this.variablesValue,

      // Template pour chaque item de la liste
      menuItemTemplate: (item) => {
        return `
          <div class="tribute-item">
            <code class="text-purple-600 font-mono">${item.original.key}</code>
            <span class="text-gray-600 text-sm ml-2">${item.original.label}</span>
          </div>
        `
      },

      // Template pour la sélection (ce qui sera inséré)
      selectTemplate: (item) => {
        // Insérer la variable complète avec les accolades
        return "{{" + item.original.key + "}}"
      },

      // Limite d'items affichés
      menuShowMinLength: 0,

      // Nombre max de résultats
      lookup: "key",

      // Matching
      fillAttr: "key"
    })

    // Attacher aux champs content
    this.contentTargets.forEach(target => {
      this.tribute.attach(target)
    })
  }
}
